import { cpf as CPF } from 'cpf-cnpj-validator'
import _ from 'lodash'
import isEqual from 'lodash.isequal'

import { plateFormatter } from '../../utils/stringFormatter'

export const voucherColumns = [
  { field: 'externalId', flex: 1.2 },
  { field: 'voucherIdentifier', flex: 1 },
  { field: 'provider', flex: 1 },
  { field: 'status', flex: 1 },
  { field: 'voucherDate', flex: 1 },
  { field: 'voucherValue', flex: 0.6 },
  { field: 'vehicleType', flex: 1 },
  { field: 'amountAxes', flex: 0.4 },
  { field: 'plate', flex: 0.6 },
]
export const columnsTitles = [
  { title: 'Carga', flex: 1.2 },
  { title: 'ID do Vale', flex: 1 },
  { title: 'Emissor', flex: 1 },
  { title: 'Status', flex: 1 },
  { title: 'Data', flex: 1 },
  { title: 'Valor', flex: 0.6 },
  { title: 'Tipo do Veículo', flex: 1 },
  { title: 'Eixos', flex: 0.4 },
  { title: 'Placa', flex: 0.6 },
]

export const voucherStatus = {
  PENDING: 'Pendente',
  PURCHASED: 'Comprado',
  CONFIRMED: 'Confirmado',
  RECUSED: 'Recusado',
  CANCELED: 'Cancelado',
  CLOSED: 'Encerrado',
}

export const VOUCHER_STATUS_COLORS = {
  PENDING: '#F2C94C',
  PURCHASED: '#2D9CDB',
  CONFIRMED: '#219653',
  CANCELED: '#FD7E14',
  RECUSED: '#EB5757',
  CLOSED: '#828282',
}

export const VOUCHER_FILTER_SCHEMA = {
  externalId: '',
  driverDocument: '',
  plate: '',
  selectedTransporter: null,
  freightDateRange: null,
  selectedDestination: null,
}

export const formatFilterData = (data) => {
  const { plate, freightDateRange, externalId, driverDocument, selectedDestination, status } = data
  let payload = {
    plate: window.btoa(plate),
    externalId,
    driverDocument: window.btoa(driverDocument),
    status,
  }
  if (selectedDestination) {
    payload.destinationId = selectedDestination
  }
  if (freightDateRange) {
    const { startDate: initDate, endDate } = freightDateRange
    payload = { ...payload, initDate, endDate }
  }

  return payload
}

export function removeFalsyProperties(obj) {
  return _.omitBy(obj, (value) => !value)
}

export const applyUrlFilters = (searchString, getFilters, getValues, reset) => {
  const filtersByUrlState = getFilters(searchString, { defaultReturnTypes: { status: [] } })
  const filterByUseForm = formatFilterData(getValues())

  const { initDate, endDate, plate, driverDocument, destinationId, status, externalId } =
    filtersByUrlState

  const newFilters = { status, externalId }

  if (initDate && endDate) {
    newFilters.freightDateRange = {
      startDate: initDate,
      endDate,
    }
  }
  if (plate) {
    newFilters.plate = plateFormatter(window.atob(plate))
  }
  if (driverDocument) {
    newFilters.driverDocument = CPF.format(window.atob(driverDocument))
  }
  if (destinationId) {
    newFilters.selectedDestination = String(destinationId)
  }

  if (!isEqual(removeFalsyProperties(filterByUseForm), filtersByUrlState)) {
    reset({ ...VOUCHER_FILTER_SCHEMA, ...newFilters })
  }
}

export const VOUCHERS_PAGINATION_SIZE = 20

export const VOUCHER_STATUS_OPTIONS = [
  { label: 'Pendente', value: 'PENDING' },
  { label: 'Comprado', value: 'PURCHASED' },
  { label: 'Confirmado', value: 'CONFIRMED' },
  { label: 'Recusado', value: 'RECUSED' },
  { label: 'Cancelado', value: 'CANCELED' },
  { label: 'Encerrado', value: 'CLOSED' },
]
